/**
 * Turn a Firebase auth error code from `sendPasswordResetEmail` into a message
 * we can put on the screen.
 *
 * Every code must produce something. The reset screen used to catch only
 * `auth/user-not-found` and let every other code fall into an empty else-if,
 * while the button had already been switched to 'Verzonden' — so a blocked
 * attempt (`auth/too-many-requests` after a few clicks) looked exactly like a
 * delivered mail. Zie docs/inbox.md Bug #222.
 *
 * The unknown branch repeats the raw code on purpose: it is the only trace
 * support has when someone reports "er gebeurt niets".
 *
 * @param {string | undefined | null} code - Firebase error code, e.g. 'auth/invalid-email'
 * @returns {string} Message in Dutch, never empty
 */
const resetPasswordMessage = (code) => {
    switch (code) {
        case 'auth/user-not-found':
            return 'Dit emailadres is niet bekend. Probeer een ander emailadres of stuur een mailtje naar info@deccos.nl'
        case 'auth/invalid-email':
        case 'auth/missing-email':
            return 'Dit is geen geldig emailadres. Controleer of het klopt, of stuur een mailtje naar info@deccos.nl'
        case 'auth/too-many-requests':
            return 'Er zijn te veel pogingen gedaan. Wacht een paar minuten en probeer het opnieuw, of stuur een mailtje naar info@deccos.nl'
        case 'auth/network-request-failed':
            return 'Er is geen verbinding met Deccos. Controleer je internetverbinding en probeer het opnieuw. Blijft het misgaan, stuur dan een mailtje naar info@deccos.nl'
        default:
            return `Het versturen is niet gelukt (${code || 'onbekende fout'}). Probeer het zo nog eens, of stuur een mailtje naar info@deccos.nl`
    }
}

export default resetPasswordMessage
